import React from 'react';

const Illinois = () => {
  return (
    <div>
      
    </div>
  );
}

export default Illinois;
